export default "__VITE_ASSET__B$IZAqlk__"